export default "__VITE_ASSET__ltB1UxM7__";